import ApiService from '../apiservice'

export default class TipoBeneficioService extends ApiService {
  constructor() {
    super('/tipo-beneficio');
  }

  cadastrar(tipo) {
    return this.post('/',tipo);
  }

  listar(empresa) {
    return this.get(`/${empresa}`);
  }

  consultar(codigo) {
    return this.get(`/por-codigo/${codigo}`);
  }

  alterar(tipo) {
    return this.put('/',tipo);
  }

  excluir(codigo) {
    return this.delete(`/${codigo}`);
  }
}
